import type { TaskNotificationStatus } from '@backoffice-frontend/graphql'

export const AssignedToMeFilter = 'MY_IN_PROGRESS'

export type AlertFilterTypes =
  | TaskNotificationStatus
  | typeof AssignedToMeFilter
  | undefined
